'use strict';

const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    /**
     * Backbone.Model を extend した UserRequestCommentModel を定義する
     */
    defaults: {
        body: ''
    },

    validation: {
        body: [
            {
                required: true,
                msg: 'input.user_request_comment.body.validation.required'
            }
        ]
    },

    editableAttributes: function() {
        const json = this.toJSON();
        delete json['id'];
        return json;
    },

    idParams: function() {
        return {
            user_request_id: this.get('user_request_id')
        };
    }
});



// WEBPACK FOOTER //
// ./feedback/domain/entity/comment.js